/* eslint-disable @typescript-eslint/no-explicit-any */

import { NewsfeedData } from '../news-newsfeed-interface/news-feed.interfaces';
import {
  isValidNewsfeedData,
  isLoadingState,
  isErrorState,
  isEmptyState,
  isEmptyPortfolioState,
} from '../news-newsfeed-interface/news-feed-validation';
import {
  Component,
  ElementRef,
  ViewChild,
  AfterViewChecked,
  ViewEncapsulation,
  OnDestroy,
  Input,
  OnChanges,
  ChangeDetectorRef,
} from '@angular/core';
import { EntityInfoService } from 'src/app/shared/services/metadata-api/entity-info.service';
import { Router, ActivatedRoute } from '@angular/router';
import { interval } from 'rxjs';
import { RoutingService } from '../../../../service/routing.service';
import { ConfigService } from '../../../../service/config.service';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { NewsViewComponent } from '../news-view/news-view.component';
import * as moment from 'moment';
import { FeatureFlagsService } from 'src/app/shared/services/customer-api/feature-flags.service';
import { QueryApiService } from 'src/app/shared/services/customer-api/query-api.service';
import { buildTextSearchQuery } from 'src/app/shared/utils/text-query.utils';
import { UserActivityApiService } from 'src/app/shared/services/customer-api/user-activity-api.service';
import { BookmarkApiService } from 'src/app/shared/services/customer-api/bookmark-api.service';
import { PortfolioApiService } from 'src/app/shared/services/customer-api/portfolio-api.service';
import { SafeHtmlPipe } from 'src/app/pipe/safehtml.pipe';
import { HighlightPipe } from 'src/app/pipe/highlight.pipe';
import { UntypedFormControl } from '@angular/forms';
import { debounceTime } from 'rxjs/operators';
import { BreakpointService } from 'src/app/shared/services/breakpoints.service';
import { NewsFeedService } from './news-feed.service';
import { NewsFeedProcessorService } from './news-feed-processor.service';
import { NewsFeedTypeHandlerService } from './news-feed-type-handler.service';
import {
  DialogResponse,
  NewsType,
  REFRESH_PARAMS,
} from '../news-newsfeed-interface/news-type.constant';
import { NewsService } from 'src/app/shared/services/data-api/news.service';
import { NewsRequestUtilService } from 'src/app/shared/utils/news-utils.service';
import { UserScopedStorageService } from 'src/app/shared/services/user-scoped-storage.service';
import { writeSearchHandoff } from 'src/app/shared/utils/search-handoff';

interface NewsViewDialogData {
  newsinfo: any;
  params: any;
  arraid: string[];
  newsfeed: any[];
  currentnews: any;
}

@Component({
  encapsulation: ViewEncapsulation.None,
  selector: 'app-news-feed',
  templateUrl: './news-feed.component.html',
  styleUrls: ['./news-feed.component.scss'],
})
export class NewsFeedComponent
  implements OnDestroy, AfterViewChecked, OnChanges
{
  @Input() newsfeedData: NewsfeedData = {};

  private processNewsfeedData(): void {
    this.emptyPortfolio = false;
    // Determine the current state
    if (isEmptyPortfolioState(this.newsfeedData)) {
      this.handleEmptyPortfolioState();
    } else if (isErrorState(this.newsfeedData)) {
      this.handleErrorState();
    } else if (isValidNewsfeedData(this.newsfeedData)) {
      this.handleValidData();
    } else if (isEmptyState(this.newsfeedData)) {
      this.handleEmptyState();
    } else if (isLoadingState(this.newsfeedData)) {
      this.handleLoadingState();
    }
  }

  private handleEmptyPortfolioState(): void {
    this.emptyPortfolio = true;
    this.nodata = false;
    this.loading = false;
    this.newsfeed = [];
    this.newsids = [];
    this.arraid = [];
  }

  private handleErrorState(): void {
    this.nodata = true;
    this.loading = false;
  }

  private handleValidData(): void {
    this.initializeParameters();
    this.initializeNewsfeedData();
  }

  private handleEmptyState(): void {
    this.nodata = false;
    this.loading = false;
    this.newsfeed = [];
    this.newsids = [];
    this.arraid = [];
  }

  private handleLoadingState(): void {
    this.loading = true;
    this.nodata = false;
  }

  @ViewChild('newsfeedContainer') newsfeedContainer: ElementRef;
  storyContentHeight = 140;

  infonews: any;
  newsfeed: any = [];
  storyNewsfeed: any = [];
  storyNewsIds: any = [];
  stars = [];
  loading: boolean = true;
  scrollnext: string;
  scrollIndex: number;
  params: any;
  intopscrol: boolean;
  chips = [];
  readyscroll: boolean = false;
  match: string;
  tag: string;
  activenews: string;
  inews: boolean;
  project: string;
  previousValue: any;
  timer: any;
  queryParamsSub: any;
  countnews = 0;
  newsids = [];
  auditedIds = [];
  dismissedIds = [];
  resolvedIds = [];
  auditedCases = [];
  dismissedCases = [];
  loadnews: number;
  duplicate = true;
  titleEntity = false;
  licensedContent = false;
  newnewsid: any;
  frametime: any;
  nodata: boolean = false;
  emptyPortfolio: boolean = false;
  arraid: any;
  newstype: string;
  bookmarked: any;
  selectedArticles = [];
  messages: any[] = [];
  showRecommendations = false;
  newsfeedCopy: any = [];
  recommendationsApplied = false;
  deduplicatedEventsTitles = new Set();
  filteredEvents = [];

  keywordSearch: UntypedFormControl;

  screenSize$ = this.breakpointService.screenSize$;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private entityInfoService: EntityInfoService,
    public routing: RoutingService,
    public dialog: MatDialog,
    public featureFlagsService: FeatureFlagsService,
    public config: ConfigService,
    private cdr: ChangeDetectorRef,
    private newsFeedService: NewsFeedService,
    private breakpointService: BreakpointService,
    private feedProcessor: NewsFeedProcessorService,
    private feedTypeHandler: NewsFeedTypeHandlerService,
    private newsService: NewsService,
    private newsRequestUtil: NewsRequestUtilService,
    private bookmarkApi: BookmarkApiService,
    public userActivityApi: UserActivityApiService,
    private portfolioApi: PortfolioApiService,
    public queryApi: QueryApiService,
    private userStorage: UserScopedStorageService,
  ) {
    this.keywordSearch = new UntypedFormControl('');
    this.keywordSearch.valueChanges
      .pipe(debounceTime(1000))
      .subscribe((value) => {
        this.loading = true;
        this.newsRequestUtil.keywords = value;
        this.router.navigate([], {
          queryParams: {
            updateNewsfeed: Math.random(),
          },
          queryParamsHandling: 'merge',
        });
      });

    this.project = this.config.appConfig.routing.project;

    this.initializeQueryParamsSubscription();
  }

  private initializeQueryParamsSubscription(): void {
    this.queryParamsSub = this.route.queryParams.subscribe((params) => {
      this.handleInitialState(params);
      this.handleStorageData();

      if (this.shouldLoadNewsView(params)) {
        this.loadNewsView(params);
      }

      this.updateContentFlags(params);

      if (this.shouldRefreshNewsfeed(params)) {
        this.setNewsType();
        this.initializeNewsLoad();
      }

      this.previousValue = params;
    });
  }

  private handleInitialState(params: any): void {
    if (!this.routing.reFresh(params, this.previousValue, ['news'])) {
      this.showRecommendations = false;
      this.selectedArticles = [];
    }
    this.params = params;
  }

  private handleStorageData(): void {
    const stored = this.userStorage.getItem('news_curation');
    if (stored) {
      this.stars = stored.split(',');
    }
  }

  private shouldLoadNewsView(params: any): boolean {
    return (
      params.news && this.routing.reFresh(params, this.previousValue, ['news'])
    );
  }

  private loadNewsView(params: any): void {
    this.newsService
      .getNewsItem(params.news, this.params)
      .subscribe((result) => {
        const viewData = this.prepareNewsViewData(result, params);
        this.logArticleActivity('article_open', params.news);
        this.openNewsViewDialog(viewData, params.news);
      });
  }

  private prepareNewsViewData(result: any, params: any): NewsViewDialogData {
    const resCopy = JSON.parse(JSON.stringify(result));
    this.loadnews = undefined;
    this.activenews = params.news;

    const highlight = this.getHighlightData(resCopy);

    return {
      newsinfo: result,
      params: { ...params, highlight },
      arraid: this.getArrayForNewsType(),
      newsfeed: this.getNewsfeedForNewsType(),
      currentnews: this.getCurrentNews(params.news),
    };
  }
  getCurrentNews(news: any): any {
    return this.newsfeed.filter((item) => {
      return item.id === news;
    })[0];
  }
  getNewsfeedForNewsType(): any[] {
    return this.newstype === 'Stories' || this.newstype === 'Relevant'
      ? this.storyNewsfeed
      : this.newsfeed;
  }
  getArrayForNewsType(): string[] {
    return this.newstype === 'Stories' || this.newstype === 'Relevant'
      ? this.storyNewsIds
      : this.arraid;
  }

  private getHighlightData(resCopy: any): string | null {
    if (
      Object.prototype.hasOwnProperty.call(resCopy, 'query_highlights') &&
      resCopy.query_highlights.length !== 0
    ) {
      return encodeURIComponent(
        JSON.stringify(
          resCopy.query_highlights.map((item) => ({
            where: item.where,
            span: item.span,
          })),
        ),
      );
    }
    return null;
  }
  private openNewsViewDialog(
    viewData: NewsViewDialogData,
    newsId: string,
  ): void {
    this.dialog
      .open(NewsViewComponent, {
        autoFocus: false,
        panelClass: 'panelNews',
        disableClose: false,
        closeOnNavigation: true,
        data: viewData,
      })
      .afterClosed()
      .subscribe((response) => this.handleDialogClose(response, newsId));
  }

  private handleDialogClose(response: string, newsId: string): void {
    if (
      response === DialogResponse.AUDITED ||
      response === DialogResponse.DISMISSED
    ) {
      this.updateNewsFeeds(newsId);
      this.updateIds(response, newsId);
    }

    this.logArticleActivity('article_close', newsId);
    this.handleNavigation(response);
  }

  private updateNewsFeeds(newsId: string): void {
    const filterCondition = (item: any) => item.id !== newsId;
    this.newsfeed = this.newsfeed.filter(filterCondition);
    this.arraid = this.newsfeed.filter(filterCondition);
    this.newsids = this.newsfeed.filter(filterCondition);
  }

  private updateIds(response: string, newsId: string): void {
    if (response === DialogResponse.AUDITED) {
      this.auditedIds.push(newsId);
    } else if (response === DialogResponse.DISMISSED) {
      this.dismissedIds.push(newsId);
    }
  }
  private handleNavigation(response: string): void {
    const baseQueryParams = {
      news: null,
      highlight: null,
      audit: null,
      dismiss: null,
      resolve: null,
      check: null,
    };

    if (response === DialogResponse.RESOLVED) {
      this.router.navigate([], {
        queryParams: { ...baseQueryParams, update: Math.random() },
        queryParamsHandling: 'merge',
        replaceUrl: true,
      });
    } else if (response !== DialogResponse.CHANGED) {
      this.router.navigate([], {
        queryParams: baseQueryParams,
        queryParamsHandling: 'merge',
        replaceUrl: false,
      });
    }
  }
  private logArticleActivity(activityType: string, articleId: string): void {
    if (this.featureFlagsService.featureFlags.activityLogging) {
      this.userActivityApi
        .userActivity({
          environment: this.config.appConfig.routing.project,
          url: this.router.url,
          activity_type: activityType,
          article_id: articleId,
        })
        .subscribe();
    }
  }

  private setNewsType(): void {
    this.newstype = this.params.newstype || NewsType.CHRONOLOGICAL;
  }

  private updateContentFlags(params: any): void {
    this.licensedContent = params.license === 'true';
    this.titleEntity = params.title === 'true';
    this.duplicate = params.duplicate ? params.duplicate === 'true' : true;
  }

  private shouldRefreshNewsfeed(params: any): boolean {
    return (
      (params.id || params.isin || this.routing.isHot()) &&
      this.routing.reFresh(params, this.previousValue, REFRESH_PARAMS)
    );
  }
  private initializeNewsLoad(): void {
    if (!this.params.title) {
      this.titleEntity = false;
    }
    if (!this.params.license) {
      this.licensedContent = false;
    }
    if (!this.params.duplicate && this.newstype !== NewsType.RELEVANT) {
      this.duplicate = false;
    }

    this.nodata = false;
    this.loading = true;
  }

  /**
   * Refresh news feed after starring/unstarring actions
   */
  private refreshNewsAfterStarring(newsId: string): void {
    if (this.newstype === 'Bookmarked') {
      this.removeNewsFromList(newsId);
    }
  }

  /**
   * Remove a specific news item from the current newsfeed list
   */
  private removeNewsFromList(newsId: string): void {
    this.newsfeed = this.newsfeed.filter((news) => news.id !== newsId);

    if (this.newsids) {
      this.newsids = this.newsids.filter((id) => id !== newsId);
    }
  }

  ngAfterViewChecked() {
    if (this.newsfeedContainer && !this.routing.isScanner()) {
      if (this.routing.isStoryReader()) {
        this.storyContentHeight =
          this.newsfeedContainer.nativeElement.offsetHeight - 172;
      } else {
        this.storyContentHeight =
          this.newsfeedContainer.nativeElement.offsetHeight - 232;
      }
      this.cdr.detectChanges();
    }
  }

  inTerval() {
    if (
      this.routing.isToday(this.params.time) &&
      !this.routing.isHot() &&
      this.newstype === 'Chronological'
    ) {
      const intervalValue = 120000;

      this.timer = interval(intervalValue).subscribe(() => {
        this.newsFeedService
          .chronologicalNewsfeed({
            params: this.params,
            custom: {
              size: 10,
            },
          })
          .subscribe((result) => {
            this.countnews = 0;
            result.news.forEach((news) => {
              if (
                !this.newsids.includes(news.id) &&
                !this.newnewsid.includes(news.id) &&
                !this.auditedIds.includes(news.id) &&
                !this.dismissedIds.includes(news.id)
              ) {
                if (
                  this.routing.isNewsaudit() &&
                  !(this.newstype === 'Flagged') &&
                  !(this.newstype === 'Dismissed')
                ) {
                  let events = [];
                  let participants = [];

                  if (news.events && news.events.length !== 0) {
                    events = Array.from(
                      new Set(
                        news.events.map((event) => {
                          if (
                            event.participants &&
                            event.participants.length !== 0
                          ) {
                            event.participants.forEach((participant) => {
                              participants.push(participant.name);
                            });
                          }
                          return event.name;
                        }),
                      ),
                    );
                  }

                  participants = Array.from(new Set(participants));

                  const noEntities = ['No entity matches'];

                  let entities = news.matches;

                  if (this.routing.isFolio() || this.routing.isHomepage()) {
                    const portfolioEntities =
                      this.portfolioApi.activePortfolio.content;
                    entities = entities
                      .filter((item) => {
                        return portfolioEntities.includes(
                          item.entity.compound_key,
                        );
                      })
                      .map((element) => element.entity.name);
                  } else {
                    entities = entities.map((element) => element.entity.name);
                  }

                  if (entities.length === 0) {
                    entities = noEntities;
                  }

                  news['auditEvents'] = events;
                  news['auditEntities'] = entities;
                  news['auditParticipants'] = participants;
                }

                news.inew = true;
                if (!news.title) {
                  news.title = news.content;
                }
                const proportions = { pos: 0, neu: 0, neg: 0 };
                news.matches.forEach((item) => {
                  if (
                    this.params.type + ':' + this.params.id ===
                    item.entity.compound_key
                  ) {
                    news.sentiment = item.sentiment;
                    if (!item.implied && item.spans.length > 0) {
                      proportions[item.sentiment] += 1;
                    }
                  } else if (
                    (this.routing.isFolio() || this.routing.isHomepage()) &&
                    this.portfolioApi.activePortfolio &&
                    !this.params.portfolioId
                  ) {
                    this.portfolioApi.activePortfolio.content.forEach(
                      (portfolioEntity) => {
                        if (portfolioEntity === item.entity.compound_key) {
                          news.sentiment = item.sentiment;
                          if (!item.implied && item.spans.length > 0) {
                            proportions[item.sentiment] += 1;
                          }
                        }
                      },
                    );
                  }
                });
                if (
                  proportions.pos !== 0 ||
                  proportions.neu !== 0 ||
                  proportions.neg !== 0
                ) {
                  const propSum =
                    proportions.pos + proportions.neu + proportions.neg;
                  news.sentiment_proportions = {
                    pos: proportions.pos / propSum,
                    neu: proportions.neu / propSum,
                    neg: proportions.neg / propSum,
                  };
                }
                // Add new news at the beginning for real-time updates
                this.newsfeed.unshift(news);
                this.newnewsid.push(news.id);
                this.newsids.unshift(news.id);
                this.countnews++;
              }
            });
            if (this.countnews > 0) {
              this.frametime = {
                today: true,
                twentyfourhours: true,
                week: true,
                month: true,
                quarter: true,
                year: true,
              };
              // Apply processing using the service
              this.feedProcessor.sortNewsfeed(this.newsfeed, this.newstype);
              // fresh reference so the OnPush list child re-renders the unshifted items
              this.newsfeed = [
                ...this.feedProcessor.filterDuplicates(
                  this.newsfeed,
                  this.duplicate,
                ),
              ];
              // Apply filters based on params
              this.newsfeed.forEach((news) => {
                this.feedProcessor.addTimeFrameLabels(
                  news,
                  this.params,
                  this.frametime,
                );
                this.feedProcessor.formatNewsTitle(news, this.params);
              });
              this.arraid = this.newsfeed.map((news) => news.id);
            }
          });
      });
    } else {
      if (this.timer) {
        this.timer.unsubscribe();
      }
    }
  }

  private initializeNewsfeedData() {
    // Initialize time frame settings
    this.frametime = {
      today: true,
      twentyfourhours: true,
      week: true,
      month: true,
      quarter: true,
      year: true,
    };

    // Initialize scroll and display settings
    this.intopscrol = true;
    this.readyscroll = true;
    this.match = this.params.id || 'all';
    this.tag = this.params.tag || '';

    // Initialize counters and flags
    this.countnews = 0;
    this.nodata = false;

    // Handle tag-related chips
    this.chips = [];
    if (this.params.tag) {
      const name = this.params.tag.split('|')[1];
      this.chips.push(name);
    }

    // Clean up existing timer if any
    if (this.timer) {
      this.timer.unsubscribe();
    }

    // Process newsfeed based on news type
    if (this.newstype === 'Stories' || this.newstype === 'Relevant') {
      this.injectNewsfeed(this.newsfeedData, false); // false for initial load
    } else {
      this.inNews();
      this.inTerval();
    }
  }

  private initializeParameters() {
    // Initialize boolean flags from params
    this.duplicate = this.params.duplicate
      ? this.params.duplicate === 'true'
      : true;
    this.titleEntity = this.params.title === 'true';
    this.licensedContent = this.params.license === 'true';

    // Reset arrays
    this.chips = [];
    this.newsfeed = [];
    this.newnewsid = [];
    this.arraid = [];

    // Reset state variables
    this.loading = true;
    this.scrollnext = 'null';
    this.scrollIndex = 0;
    this.newstype = this.params.newstype || 'Chronological';
  }

  /**
   * Lifecycle hook that is called when data-bound properties of a directive change.
   * Handles initialization and updates of the newsfeed component.
   */
  ngOnChanges() {
    this.processNewsfeedData();
  }

  ngOnDestroy() {
    if (this.timer) {
      this.timer.unsubscribe();
    }
    if (this.queryParamsSub) {
      this.queryParamsSub.unsubscribe();
    }
    this.newsRequestUtil.keywords = '';
  }

  injectNewsfeed(result, isScrollLoad: boolean = false) {
    // 1) STORIES (or Relevant-with-stories)
    if (
      (this.newstype === 'Stories' &&
        Object.prototype.hasOwnProperty.call(result, 'stories')) ||
      (this.newstype === 'Relevant' &&
        Object.prototype.hasOwnProperty.call(result, 'stories'))
    ) {
      this.handleStoriesNewsfeed(result);
    }
    // 2) NEWSAUDIT (not Flagged / not Dismissed) — ASYNC
    else if (
      this.routing.isNewsaudit() &&
      !(this.newstype === 'Flagged') &&
      !(this.newstype === 'Dismissed')
    ) {
      this.handleNewsAuditNewsfeed(result, isScrollLoad);
    }
    // 3) NEWSAUDIT (Flagged)
    else if (this.routing.isNewsaudit() && this.newstype === 'Flagged') {
      this.handleFlaggedNewsfeed(result, isScrollLoad);
    }
    // 4) NEWSAUDIT (Dismissed)
    else if (this.routing.isNewsaudit() && this.newstype === 'Dismissed') {
      this.handleDismissedNewsfeed(result, isScrollLoad);
    }
    // 5) Standard newsfeed
    else if (result.news) {
      this.handleStandardNewsfeed(result, isScrollLoad);
    }
  }

  /**
   * Handle stories type newsfeed
   */
  private handleStoriesNewsfeed(result: any): void {
    const processedData = this.feedTypeHandler.processStoriesNewsfeed(result);
    // Stories don't support scroll loading, always replace
    this.newsfeed = processedData.newsfeed;
    this.loading = processedData.loading;
  }

  /**
   * Handle news audit newsfeed
   */
  private handleNewsAuditNewsfeed(
    result: any,
    isScrollLoad: boolean = false,
  ): void {
    this.feedTypeHandler
      .processNewsAuditNewsfeed(result, this.params)
      .subscribe((processedData) => {
        this.applyProcessedData(processedData, isScrollLoad);
      });
  }

  /**
   * Handle flagged newsfeed
   */
  private handleFlaggedNewsfeed(
    result: any,
    isScrollLoad: boolean = false,
  ): void {
    this.feedTypeHandler
      .processFlaggedNewsfeed(result, this.params)
      .subscribe((processedData) => {
        this.applyProcessedData(processedData, isScrollLoad);

        // Handle navigation for empty flagged news
        if (this.newsfeed.length === 0 && this.params.newstype === undefined) {
          this.router.navigate([], {
            queryParams: { newstype: 'Chronological' },
            queryParamsHandling: 'merge',
            replaceUrl: true,
          });
        }
      });
  }

  /**
   * Handle dismissed newsfeed
   */
  private handleDismissedNewsfeed(
    result: any,
    isScrollLoad: boolean = false,
  ): void {
    this.feedTypeHandler
      .processDismissedNewsfeed(result, this.params)
      .subscribe((processedData) => {
        this.applyProcessedData(processedData, isScrollLoad);

        // Handle navigation for empty dismissed news
        if (this.newsfeed.length === 0 && this.params.newstype === undefined) {
          this.router.navigate([], {
            queryParams: { newstype: 'Chronological' },
            queryParamsHandling: 'merge',
            replaceUrl: true,
          });
        }
      });
  }

  /**
   * Handle standard newsfeed (chronological, events, etc.)
   */
  private handleStandardNewsfeed(
    result: any,
    isScrollLoad: boolean = false,
  ): void {
    const processedData = this.feedTypeHandler.processStandardNewsfeed(
      result,
      this.params,
      this.newstype,
    );
    this.applyProcessedData(processedData, isScrollLoad);
  }

  /**
   * Apply processed data to component properties
   */
  private applyProcessedData(
    processedData: any,
    isScrollLoad: boolean = false,
  ): void {
    if (isScrollLoad) {
      // Append to existing data for scroll loads
      this.newsfeed = [...this.newsfeed, ...processedData.newsfeed];
      this.newsids = [...this.newsids, ...(processedData.newsids || [])];
    } else {
      // Replace data for initial loads
      this.newsfeed = processedData.newsfeed;
      this.newsids = processedData.newsids || [];
    }

    this.loading = processedData.loading;

    // Update scroll state based on news type
    if (this.newstype === 'Relevant' || this.newstype === 'Chronological') {
      // For these types, use from_index from the response
      this.scrollnext = processedData.scrollnext || 'null';
      this.scrollIndex = 0;
      this.readyscroll = this.scrollnext !== 'null';
    } else if (isScrollLoad) {
      // For scroll loads of other types, increment the index
      this.scrollIndex += processedData.scrollIndex || 50;
      this.scrollnext = 'null';
      this.readyscroll = true;
    } else {
      // For initial loads of other types
      this.scrollIndex = processedData.scrollIndex || 0;
      this.scrollnext = 'null';
      this.readyscroll = this.scrollIndex > 0;
    }

    if (processedData.auditedIds) {
      this.auditedIds = processedData.auditedIds;
    }
    if (processedData.dismissedIds) {
      this.dismissedIds = processedData.dismissedIds;
    }

    // Update arraid
    this.arraid = this.newsfeed.map((news) => news.id);
  }

  inNews() {
    if (
      this.readyscroll &&
      (this.scrollnext != null || this.scrollIndex !== 0)
    ) {
      if (this.newsfeed.length) {
        this.readyscroll = false;
      }

      if (
        this.newsfeedData &&
        this.scrollnext === 'null' &&
        this.scrollIndex === 0
      ) {
        this.injectNewsfeed(this.newsfeedData, false); // initial load from data
      } else if (this.scrollnext !== 'null' || this.scrollIndex !== 0) {
        this.newsFeedService
          .newsFeed({
            newsType: this.newstype as NewsType,
            returnEvents: this.newstype === 'Events',
            params: this.params,
            custom: {
              from_index:
                this.newstype === 'Chronological'
                  ? this.scrollnext
                  : this.scrollIndex,
              size: this.newstype !== 'Events' ? 50 : 1000,
              starred_only: this.newstype === 'Bookmarked',
              audited_only: this.newstype === 'Flagged',
              dismissed_only: this.newstype === 'Dismissed',
              top_news_score_threshold: false,
              license: false,
              title: false,
            },
          })
          .subscribe(
            (result) => {
              this.injectNewsfeed(result, true); // true for scroll load
            },
            () => {
              this.nodata = true;
              this.loading = false;
            },
          );
      } else {
        this.nodata = true;
        this.loading = false;
      }
    } else {
      this.loading = false;
    }
  }

  inScrolled() {
    if (this.newstype !== 'Stories' && this.newstype !== 'Relevant') {
      this.inNews();
    }
  }
  inScrolling(event): void {
    if (event.target.scrollTop === 0) {
      this.intopscrol = true;
    } else {
      this.intopscrol = false;
    }
  }

  goNews(newsArg, type) {
    let news;
    if (type === 'feedstories') {
      news = newsArg.news;
      this.storyNewsfeed = newsArg.story.news;
      this.storyNewsIds = newsArg.story.news.map((item) => {
        return item.id;
      });
    } else if (type === 'feedstories2') {
      news = newsArg.news;
      this.storyNewsfeed = [newsArg.story.article];
      this.storyNewsIds = [newsArg.story.article.id];
    } else {
      news = newsArg;
    }
    this.loadnews = news.id;
    if (this.activenews === news.id) {
      this.activenews = undefined;
    } else {
      this.activenews = news.id;
    }

    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: {
        news: news.id,
        audit: this.routing.isNewsaudit() ? type === 'audit' : null,
        dismiss: this.routing.isNewsaudit() ? type === 'dismiss' : null,
        resolve: this.routing.isNewsaudit() ? type === 'resolve' : null,
        check: this.routing.isNewsaudit() ? type === 'check' : null,
        note: null,
      },
      queryParamsHandling: 'merge',
      replaceUrl: false,
      skipLocationChange: false,
    });
  }

  dismissNews(item) {
    let check = false;
    const filteredArticles = this.selectedArticles.filter((news) => {
      if (news.id === item.id) {
        check = true;
      }
      return news.id !== item.id;
    });
    if (check) {
      this.selectedArticles = filteredArticles;
    } else {
      this.selectedArticles.push(item);
    }
  }

  removeChip() {
    this.router.navigate([], {
      queryParams: { tag: null, newsday: null, note: null },
      queryParamsHandling: 'merge',
      replaceUrl: false,
    });
  }

  formatTitle(news) {
    this.feedProcessor.formatNewsTitle(news, this.params);
    return news;
  }

  // Old implementation kept for reference - can be removed
  formatTitleOld(news) {
    if (news) {
      if (news.reduce_visibility) {
        let title = '';
        news.matches.map((data) => {
          title += data.entity.alpha_id + ' ';
        });
        news.titleFormatted = title;
      } else if (this.params.newstype === 'Events' && this.params.eventid) {
        let title = '';
        const eventSpans = news.events.filter((item) => {
          return item.id === this.params.eventid;
        });
        const firstSpan = eventSpans[0];
        if (firstSpan && firstSpan.where === 'title') {
          title =
            news && news.title
              ? news.title.substring(firstSpan.span.start, firstSpan.span.end)
              : '';
          const newsCopy = JSON.parse(JSON.stringify(news));
          const safeHtmlPipe = new SafeHtmlPipe();
          const highlightPipe = new HighlightPipe();
          title = safeHtmlPipe.transform(title);
          const joinedSpans = {
            spans: [],
          };
          newsCopy.matches.forEach((item) => {
            const titleSpans = item.spans
              .filter((span) => {
                return span.location === 'title';
              })
              .map((span) => {
                return Object.assign({}, span, { sentiment: 'title' });
              });
            let tagactive;
            if (this.params.tag) {
              tagactive = decodeURI(this.params.tag.split('|')[0]).split(':');
            }
            if (
              this.params.tag &&
              tagactive[1] + ':' + tagactive[2] === item.entity.compound_key
            ) {
              if (!item.implied && titleSpans && titleSpans.length > 0) {
                joinedSpans.spans = joinedSpans.spans.concat(titleSpans);
              }
            } else if (this.params.participant === item.entity.compound_key) {
              if (!item.implied && titleSpans && titleSpans.length > 0) {
                joinedSpans.spans = joinedSpans.spans.concat(titleSpans);
              }
            } else if (
              this.params.type + ':' + this.params.id ===
              item.entity.compound_key
            ) {
              if (!item.implied && titleSpans && titleSpans.length > 0) {
                joinedSpans.spans = joinedSpans.spans.concat(titleSpans);
              }
            } else if (
              (this.routing.isFolio() || this.routing.isHomepage()) &&
              this.portfolioApi.activePortfolio &&
              !this.params.portfolioId
            ) {
              this.portfolioApi.activePortfolio.content.forEach(
                (portfolioEntity) => {
                  if (portfolioEntity === item.entity.compound_key) {
                    if (!item.implied && titleSpans && titleSpans.length > 0) {
                      joinedSpans.spans = joinedSpans.spans.concat(titleSpans);
                    }
                  }
                },
              );
            }
          });
          title = highlightPipe.transform(title, 'title', joinedSpans);
        } else if (firstSpan && firstSpan.where === 'content') {
          title =
            news && news.content
              ? news.content.substring(firstSpan.span.start, firstSpan.span.end)
              : '';
          const newsCopy = JSON.parse(JSON.stringify(news));
          const safeHtmlPipe = new SafeHtmlPipe();
          const highlightPipe = new HighlightPipe();
          title = safeHtmlPipe.transform(title);
          const joinedSpans = {
            spans: [],
          };
          newsCopy.matches.forEach((item) => {
            const contentSpans = item.spans
              .filter((span) => {
                return (
                  span.location === 'content' &&
                  span.start >= firstSpan.span.start &&
                  span.end <= firstSpan.span.end
                );
              })
              .map((span) => {
                return Object.assign({}, span, {
                  sentiment: 'title',
                  start: span.start - firstSpan.span.start,
                  end: span.end - firstSpan.span.start,
                });
              });
            let tagactive;
            if (this.params.tag) {
              tagactive = decodeURI(this.params.tag.split('|')[0]).split(':');
            }
            if (
              this.params.tag &&
              tagactive[1] + ':' + tagactive[2] === item.entity.compound_key
            ) {
              if (!item.implied && contentSpans && contentSpans.length > 0) {
                joinedSpans.spans = joinedSpans.spans.concat(contentSpans);
              }
            } else if (this.params.participant === item.entity.compound_key) {
              if (!item.implied && contentSpans && contentSpans.length > 0) {
                joinedSpans.spans = joinedSpans.spans.concat(contentSpans);
              }
            } else if (
              this.params.type + ':' + this.params.id ===
              item.entity.compound_key
            ) {
              if (!item.implied && contentSpans && contentSpans.length > 0) {
                joinedSpans.spans = joinedSpans.spans.concat(contentSpans);
              }
            } else if (
              (this.routing.isFolio() || this.routing.isHomepage()) &&
              this.portfolioApi.activePortfolio &&
              !this.params.portfolioId
            ) {
              this.portfolioApi.activePortfolio.content.forEach(
                (portfolioEntity) => {
                  if (portfolioEntity === item.entity.compound_key) {
                    if (
                      !item.implied &&
                      contentSpans &&
                      contentSpans.length > 0
                    ) {
                      joinedSpans.spans =
                        joinedSpans.spans.concat(contentSpans);
                    }
                  }
                },
              );
            }
          });
          title = highlightPipe.transform(title, 'content', joinedSpans);
        }
        if (!title) {
          title =
            'Click to see text - event span unavailable due to reprocessing';
          news.hidden = true;
          // this.cdr.detectChanges();
        } else if (this.duplicate) {
          if (!this.deduplicatedEventsTitles.has(title)) {
            this.deduplicatedEventsTitles.add(title);
            this.filteredEvents.push(news.id);
          }
          if (
            this.deduplicatedEventsTitles.has(title) &&
            !this.filteredEvents.includes(news.id)
          ) {
            news.hidden = true;
            // this.cdr.detectChanges();
          }
        }
        news.titleFormatted = title;
      } else {
        const newsCopy = JSON.parse(JSON.stringify(news));
        let title = newsCopy.title;
        const safeHtmlPipe = new SafeHtmlPipe();
        const highlightPipe = new HighlightPipe();
        title = safeHtmlPipe.transform(title);
        const joinedSpans = {
          spans: [],
        };
        newsCopy.matches.forEach((item) => {
          item.spans.forEach((span) => {
            span.sentiment = 'title';
          });
          let tagactive;
          if (this.params.tag) {
            tagactive = decodeURI(this.params.tag.split('|')[0]).split(':');
          }
          if (
            this.params.tag &&
            tagactive[1] + ':' + tagactive[2] === item.entity.compound_key
          ) {
            if (!item.implied && item.spans && item.spans.length > 0) {
              joinedSpans.spans = joinedSpans.spans.concat(item.spans);
            }
          } else if (this.params.participant === item.entity.compound_key) {
            if (!item.implied && item.spans && item.spans.length > 0) {
              joinedSpans.spans = joinedSpans.spans.concat(item.spans);
            }
          } else if (
            this.params.type + ':' + this.params.id ===
            item.entity.compound_key
          ) {
            if (!item.implied && item.spans && item.spans.length > 0) {
              joinedSpans.spans = joinedSpans.spans.concat(item.spans);
            }
          } else if (
            (this.routing.isFolio() || this.routing.isHomepage()) &&
            this.portfolioApi.activePortfolio &&
            !this.params.portfolioId
          ) {
            this.portfolioApi.activePortfolio.content.forEach(
              (portfolioEntity) => {
                if (portfolioEntity === item.entity.compound_key) {
                  if (!item.implied && item.spans && item.spans.length > 0) {
                    joinedSpans.spans = joinedSpans.spans.concat(item.spans);
                  }
                }
              },
            );
          }
        });
        title = highlightPipe.transform(title, 'title', joinedSpans);
        news.titleFormatted = title;
      }
    } else {
      news.titleFormatted = '';
    }
    return news;
  }

  inFrame(news) {
    let itime = false;
    if (this.params.time) {
      itime = this.params.time.split('--')[1];
    }
    if (!this.params.newsday && !itime) {
      const time = moment(news.publish_time).valueOf();
      news.time = undefined;

      if (!this.newsfeedData.fromAssistedBookmarking) {
        if (
          this.frametime.today &&
          moment().subtract(1, 'days').endOf('day').valueOf() < time
        ) {
          this.frametime.today = false;
          news.time = 'TODAY';
        } else if (
          this.frametime.twentyfourhours &&
          moment().subtract(1, 'days').endOf('day').valueOf() > time &&
          moment().subtract(1, 'days').valueOf() < time
        ) {
          this.frametime.twentyfourhours = false;
          news.time = '24 HOURS';
        } else if (
          this.frametime.week &&
          moment().subtract(1, 'days').valueOf() > time &&
          moment().subtract(7, 'days').valueOf() < time
        ) {
          this.frametime.week = false;
          news.time = 'WEEK';
        } else if (
          this.frametime.month &&
          moment().subtract(7, 'days').valueOf() > time &&
          moment().subtract(30, 'days').valueOf() < time
        ) {
          this.frametime.month = false;
          news.time = 'MONTH';
        } else if (
          this.frametime.quarter &&
          moment().subtract(30, 'days').valueOf() > time &&
          moment().subtract(90, 'days').valueOf() < time
        ) {
          this.frametime.quarter = false;
          news.time = 'QUARTER';
        } else if (
          this.frametime.year &&
          moment().subtract(90, 'days').valueOf() > time
        ) {
          this.frametime.year = false;
          news.time = 'YEAR';
        }
      }

      news.hidden = false;
      if (
        this.params.time === '2' &&
        moment().subtract(1, 'days').valueOf() > time &&
        moment().subtract(7, 'days').valueOf() < time
      ) {
        news.hidden = true;
      }
    }
    return news;
  }

  iSort(newsfeed) {
    if (this.newstype && this.newstype !== 'Relevant') {
      newsfeed.sort(
        (a, b) =>
          new Date(b.publish_time).valueOf() -
          new Date(a.publish_time).valueOf(),
      );
    }
  }

  iDuplicate(value) {
    if (this.duplicate) {
      this.deduplicatedEventsTitles = new Set();
      this.filteredEvents = [];
      if (!this.routing.isNewsletter()) {
        value.reverse();
      }
      const seenDuplicateGroupIds = new Set();
      const seenTitles = new Set();
      const filtered = [];
      value.forEach((doc) => {
        if (
          !seenDuplicateGroupIds.has(doc.duplicate_group_id) &&
          (!seenTitles.has(doc.title) || !doc.title)
        ) {
          if (this.newstype !== 'Events') {
            seenDuplicateGroupIds.add(doc.duplicate_group_id);
          }
          seenTitles.add(doc.title);
          filtered.push(doc);
        }
      });
      return !this.routing.isNewsletter() ? filtered.reverse() : filtered;
    } else {
      return value;
    }
  }

  iLicensedContent(newsfeed) {
    if (this.licensedContent) {
      if (
        this.newstype === 'Chronological' &&
        !this.params.license &&
        newsfeed.length === 0
      ) {
        return newsfeed;
      } else {
        return newsfeed;
      }
    } else {
      return newsfeed;
    }
  }

  iTitleEntity(newsfeed) {
    if (this.titleEntity) {
      if (
        this.newstype === 'Chronological' &&
        !this.params.title &&
        newsfeed.length === 0
      ) {
        return newsfeed;
      } else {
        return newsfeed;
      }
    } else {
      return newsfeed;
    }
  }

  /**
   * bookmark the news
   */
  addStar(id) {
    if (this.stars.includes(id)) {
      this.bookmarkApi.delStars(id).subscribe(() => {
        // fresh reference so the OnPush list child re-renders the star state
        this.stars = this.stars.filter((star) => star !== id);
        this.userStorage.setItem('news_curation', this.stars.join(','));
        this.refreshNewsAfterStarring(id);
      });
    } else {
      this.bookmarkApi.addStars(id).subscribe(() => {
        this.stars = [...this.stars, id];
        this.userStorage.setItem('news_curation', this.stars.join(','));
      });
    }
  }

  /**
   * build search query based on the entities name to find more articles
   */
  buildSearchQuery() {
    if (this.params.type && this.params.id && this.params.id !== 'default') {
      const compoundKey = this.params.type + ':' + this.params.id;
      this.entityInfoService
        .getEntitiesInfo([compoundKey], 'array')
        .subscribe((res) => {
          const entityName = res[0].name;
          this.queryApi.query = {
            name: entityName,
            query: buildTextSearchQuery(entityName),
          };
          writeSearchHandoff(this.queryApi.query);

          let currentView = this.routing.getPathSegment(4);
          if (
            !currentView ||
            currentView === 'main' ||
            currentView === 'scanner' ||
            currentView === 'newsfeed' ||
            currentView === 'audit'
          ) {
            currentView = 'chart';
          }

          this.router.navigate([`/cockpit/news/search/${currentView}`], {
            queryParams: {
              type: null,
              id: Math.random(),
              eventid: null,
              eventype: null,
              scoreevent: null,
              tag: null,
              participant: null,
              newstype: 'Chronological',
              newsaudit: null,
              portfolioId: null,
              groupId: null,
              eventsFromScanner: null,
              score: null,
              focused_score: null,
              time: null,
            },
            queryParamsHandling: 'merge',
          });
        });
    }
  }
}
